import {get_token,get_user_details} from "@/router";
import Swal from 'sweetalert2';
import CreateSubject from "@/components/CreateSubject/CreateSubject.vue";
import { client_domain } from "@/main.js";


import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
export default {
  components: {
    CreateSubject,
    Multiselect
  },
  mounted() {
    this.fecthsubjects();
    this.fetch_grouped_tags();
    this.token_exists = get_token();
    this.user_details=get_user_details();
    if (client_domain.includes("soulcity") ||
      client_domain.includes("nsp")) {
      this.soulcity_domain = true;
    }
  },
  props: {
    subjects: {
      type: Array,
      required: true
    }},

  data() {
    return ({
      subjects:[],
      portals: [],
      members: [],
      users:[],
      topic:'',
      topic_id:'',
      portal_id:'',
      is_public: true,
      isLoading: true,
      token_exists: false,
      topic_name: '',
      isSubmitting: false,
      errors: {},
      searchQuery: "",
      portal_creater:'',
      user_details: {
        "user_role": '',
        "first_name": '',
        "last_name": '',
        
      },
      categories: [],
      validTagIds: [],
      tag_ids: [],
      category_ids: [],
      selectedCategory: null,
      selectedFilters: new Map(),
      selectedCategories: {},
      soulcity_domain: false,
    });
  },


  methods: {

    openAssignTags(subjectId) {
    // Close Subjects modal
    $('#subjectsModal').modal('hide');

    // Open Assign Tags modal
    $('#assignTagsModal-' + subjectId).modal('show');
},
    groupTagsByCategory(subjectTags) {
  if (!Array.isArray(subjectTags)) return [];

  // Map: key = categoryId, value = { name, id, tags: [...] }
  const groupedMap = subjectTags.reduce((acc, t) => {
    const category = t?.tag?.tag_category;
    if (!category?.id) return acc;

    const categoryId = category.id;
    const categoryName = category.name || "Uncategorized";

    if (!acc.has(categoryId)) {
      acc.set(categoryId, { name: categoryName, id: categoryId, tags: [] });
    }

    acc.get(categoryId).tags.push(t);
    return acc;
  }, new Map());

  // Convert Map to an array of [categoryData, tagsArray] for Vue v-for
  return Array.from(groupedMap.values());
},
    fetch_grouped_tags() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_tags/`,
        method: 'GET',
        headers: {
          Authorization: `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: response => {
          if (response.status === 'success') {
            const tag_list = response.data.tags;

            // ✅ store allowed tag ids for validation
            this.validTagIds = tag_list.map(tag => String(tag.id));

            const grouped = new Map();

            tag_list.forEach(tag => {
              const categoryName = tag.tag_category.name;
              const categoryId = tag.tag_category.id;

              if (!grouped.has(categoryName)) {
                grouped.set(categoryName, {
                  id: categoryId,
                  tags: []
                });
              }

              grouped.get(categoryName).tags.unshift({
                id: tag.id,
                name: tag.name
              });
            });

            this.categories = Array.from(grouped.entries()).map(
              ([name, { id, tags }]) => ({
                key: name.toLowerCase().replace(/\s+/g, '-'),
                id, // ✅ category id included here
                name,
                tags
              })
            );

            this.all_tags_by_category = grouped;
            this.categoryOptions = ['all', ...Array.from(grouped.keys()).sort()];
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },

    assignTags(subjectId) {
        const selected_category = this.category_ids.map(category => {
    // Handle Vue proxy or plain object
    if (category && typeof category === 'object' && 'id' in category) {
      return category.id;
    }
    return category; // if it's already an ID
  });

    const payload = {
      subject_id: subjectId,
      category_ids: selected_category
    };
      
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/assign_tags_to_subject/`,
      method: "POST",
      headers: {
        Authorization: `Token ${this.getToken()}`,
        "Content-Type": "application/json"
      },
      data: JSON.stringify(payload),
      success: (response) => {
        if (response.status === "success") {

          $(`#assignTagsModal-${subjectId}`).modal("hide");
          this.category_ids = [];
          this.fecthsubjects();

        $('#subjectsModal').modal('show');
        }
      }
    });
  },

  unassignTag(subjectId, categoryId) { // Find the category ID for the clicked categoryName

    const payload = {
      subject_id: subjectId,
      category_id: categoryId // send only the clicked category
    };

    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/unassign_tags_to_subject/`,
      method: "POST",
      headers: {
        Authorization: `Token ${this.getToken()}`,
        "Content-Type": "application/json"
      },
      data: JSON.stringify(payload),
      success: (response) => {
        if (response.status === "success") {
          // Remove the category locally to update UI immediately
          const subject = this.subjects.find(s => s.id === subjectId);
          if (subject) {
          subject.subject_tags = subject.subject_tags.filter(
            tag => tag.tag.tag_category.id !== categoryId
          );
          }
        }
      }
    });
  },

    getToken() {
      return get_token();
    },
    get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
  },
  getProfileLink(member) {
    // Check if the user is an admin
    if (member.role.role === 'admin') {
      // Return the link for admin profiles
      return ``;
    } else if (member.role.role === 'user') {
      // Return the link for user profiles
      return `/profile?user_id=${member.id}`;
    } else {
      // Return a default profile link for other roles
      return ``;
    }
  },
  

  handleTopicClick(topicId) {
    this.$emit('topic_selected', topicId);
  },

    fecthsubjects() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_subjects/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          var status = response.status
          if(status === "success") {
            this.$nextTick(() => {
              this.subjects=  response.subjects;
              this.isLoading = false;
            });
          }

        },

        complete: () => {
          this.isLoading = false;
        }
      });
    },

    fetchReportsByTopic(topicId) {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_reports_by_topic/`,
        type: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          topic_id: topicId
        }),
        success: (response) => {
          if (response.status === "success") {
            this.reports = response.reports;
          } else {
            Swal.fire({
              title: 'Error',
              text: response.message || 'Failed to fetch reports',
              icon: 'error',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },


  //   fetchPortals() {
  //     this.isLoading = true;
  //     this.portal_id=this.$route.params.portal_id
  //     $.ajax({
  //     url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_portals_api/`,
  //     method: 'POST',
  //     headers: {
  //         'Authorization': `Token ${this.getToken()}`,
  //         'Content-Type': 'application/json'
  //     },
  //     success: (data) => {
  //         this.portals = data.portals;
  //         const visible=this.portals.find(portal_id => portal_id.id === parseInt(this.portal_id, 10));
  //         if (visible) {
  //           this.is_public = visible.is_public;
  //         }
  //     },
  //     complete: () => {
  //         this.isLoading = false;
  //     }
  //     });
  // },

  // fetch_users() {
  //   return new Promise((resolve) => {

  //     const portalId = this.$route.params.portal_id;
  //   $.ajax({
  //     type: 'GET',
  //     data:{portal_id:portalId},
  //     url: process.env.VUE_APP_BACKEND_API_URL + '/system_management/retrieve_users/',
  //     headers: {
  //       'Authorization': `Token ${this.getToken()}`,
  //     },
  //     success: (response) => {
  //       this.users = response.data.users_list;
  //       resolve();
  //     },
  //   });
  // });
  // },

    handleSubmit() {
      if (this.validateTopicForm()) { 
        this.isSubmitting = true;

        const requestData = {
          topic_name: this.topic_name,
          portal_id: this.$route.params.portal_id
        };
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_topic_api/`,
        contentType: "application/json",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(requestData),
        success: (response) => {
          
          const status = response.status;
          
          if (status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Segment Created Successfully',
              showConfirmButton: false,
              timer: 1000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              window.location.reload();
              $('#create_topic').modal('hide');
            });
          } else if (status === "error") {
            Swal.fire({
              icon: 'error',
              title: 'Creation Failed',
              text: response.message || 'An error occurred. Please try again.',
              confirmButtonText: 'Retry',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Unexpected Response',
              text: 'The server returned an unexpected response.',
              confirmButtonText: 'Okay',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          }
        },
        error: (response) => {
          const response_data = response.responseJSON;
          if(response_data.status=="error"){
           this.errors.topic_name=response_data.message
          }
      },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    }
   },

   getTagsByCategory(categoryId) {
      // Filter tags for the selected category
      // Assuming each category has a `tags` array
      const category = this.categories.find(cat => cat.id === categoryId);
      return category ? category.tags : [];
    },
  validateTopicForm() {
    this.errors = {};
    let isValid = true;
    if (!this.topic_name.trim()) {
      this.errors.topic_name = 'Segment name is required.';
      isValid = false;
    }
    return isValid;
  },
  },
};
